import {PrepareXlsxHandlingRequestRestDto, XlsxMetadataRestDto} from "@/api/pharma-cpc-import/models";
import {XlsxMetadataRestDtoModel} from "@/models/api/pharma-cpc-import/XlsxMetadataRestDtoModel";

export class PrepareXlsxHandlingRequestRestDtoModel implements PrepareXlsxHandlingRequestRestDto {
    document_key: string;
    xlsx_metadata: XlsxMetadataRestDto;

    constructor(document_key: string, xlsx_metadata: XlsxMetadataRestDto) {
        this.document_key = document_key;
        this.xlsx_metadata = xlsx_metadata;
    }

    static createWithDefaults(): PrepareXlsxHandlingRequestRestDtoModel {
        return new this('',XlsxMetadataRestDtoModel.createWithDefaults());
    }
}
